import {
  getClaimData,
  getCategoryData,
  getTop5ClaimData,
  getBrandData,
  getBrandSelect,
  getProductCategory,
  getCategoryClaim,
  getDetailMarket,
  getDetailShare,
  getClickData,
  getCommentData,
  getProductClaim,
  getNewProduct,
  getProcductDistr,
  getTop10Product,
  getFunction,
  getFunctionClaim,
  getTrendData,
  getAnnualData,
  getConsumerAnn,
  getBrandGroup,
  getCountryData,
  getBrandYear,
  getPositionMap,
  getGroupList,
  getSubCategory,
  getAreaDetail,
  getSegmentList,
  getBrandDetail,
  getExportCount,
  getBrandSuggested,
  getUpdateItem,
  getOriginList,
  getAgeData,
  getRelateBasfProducts,
  getConsumerClickData,
  getConsumerCommentData,
  getCommentProvincesData,
  getCountryNamesData
} from '@/axios/api/brandAnalytics'
// import { Message } from 'element-ui'

const UPDATE_BRAND_SEARCH_LIST = 'UPDATE_BRAND_SEARCH_LIST'
const UPDATE_BRAND_LIST = 'UPDATE_BRAND_LIST'
const UPDATE_PAGER = 'UPDATE_PAGER'
const UPDATE_CLAIM_LIST = 'UPDATE_CLAIM_LIST'
const UPDATE_CATEGORY_LIST = 'UPDATE_CATEGORY_LIST'
const UPDATE_TOP5_CLAIM = 'UPDATE_TOP5_CLAIM'
const UPDATE_PRODUCT_CATEGORY = 'UPDATE_PRODUCT_CATEGORY'
const UPDATE_CATEGORY_CLAIM = 'UPDATE_CATEGORY_CLAIM'
const UPDATE_DETAIL_MARKET = 'UPDATE_DETAIL_MARKET'
const UPDATE_DETAIL_SHARE = 'UPDATE_DETAIL_SHARE'
const UPDATE_CLICK_COUNT = 'UPDATE_CLICK_COUNT'
const UPDATE_COMMENT_COUNT = 'UPDATE_COMMENT_COUNT'
const UPDATE_PRODUCT_CLAIM = 'UPDATE_PRODUCT_CLAIM'
const UPDATE_NEW_PRODUCT = 'UPDATE_NEW_PRODUCT'
const UPDATE_PRODUCT_DISTR = 'UPDATE_PRODUCT_DISTR'
const UPDATE_TOP10_PRODUCT = 'UPDATE_TOP10_PRODUCT'
const UPDATE_FUNCTION = 'UPDATE_FUNCTION'
const UPDATE_FUNCTION_CLAIM = 'UPDATE_FUNCTION_CLAIM'
const UPDATE_TREND_DATA = 'UPDATE_TREND_DATA'
const UPDATE_ANNUAL_DATA = 'UPDATE_ANNUAL_DATA'
const UPDATE_CONSUMER_ANN = 'UPDATE_CONSUMER_ANN'
const UPDATE_BRAND_GROUP = 'UPDATE_BRAND_GROUP'
const UPDATE_COUNTRY = 'UPDATE_COUNTRY'
const UPDATE_BRAND_YEAR = 'UPDATE_BRAND_YEAR'
const UPDATA_POSITION_MAP = 'UPDATA_POSITION_MAP'
const UPDATE_GROUP_LIST = 'UPDATE_GROUP_LIST'
const UPDATE_GROUP_LIST2 = 'UPDATE_GROUP_LIST2'
const UPDATE_SUB_CATEGORY = 'UPDATE_SUB_CATEGORY'
const UPDATE_AREA_DETAIL = 'UPDATE_AREA_DETAIL'
const UPDATE_SEGMENT_LIST = 'UPDATE_SEGMENT_LIST'
const UPDATE_SUB_SEGMENT_LIST = 'UPDATE_SUB_SEGMENT_LIST'
const UPDATE_USING_TREND = 'UPDATE_USING_TREND'
const UPDATE_BRAND_DETAIL = 'UPDATE_BRAND_DETAIL'
const UPDATE_EXPORT_COUNT = 'UPDATE_EXPORT_COUNT'
const UPDATE_BRAND_SUGGESTED = 'UPDATE_BRAND_SUGGESTED'
const UPDATE_ORIGIN_LIST = 'UPDATE_ORIGIN_LIST'
const UPDATE_AGE_DATA = 'UPDATE_AGE_DATA'
const UPDATE_RELATED_BASF_PRODUCTS = 'UPDATE_RELATED_BASF_PRODUCTS'
const UPDATE_CONSUMER_CLICK_DATA = 'UPDATE_CONSUMER_CLICK_DATA'
const UPDATE_CONSUMER_COMMENT_DATA = 'UPDATE_CONSUMER_COMMENT_DATA'
const UPDATE_COMMENT_PROVINCES_DATA = 'UPDATE_COMMENT_PROVINCES_DATA'
const UPDATE_COUNTRY_NAMES_LIST = 'UPDATE_COUNTRY_NAMES_LIST'
const UPDATE_SEARCH_CLAIM_LIST = 'UPDATE_SEARCH_CLAIM_LIST'

const state = {
  brandSearchList: [],
  brandList: [],
  pager: {
    current: 1,
    total: 0,
    size: 10
  },
  total: 0,
  claimList: [],
  categoryList: [],
  top5Claim: [],
  productCategory: {
    listdata: []
  },
  categoryClaim: {
    categoryDetail: [],
    claimDetail: []
  },
  detailMarket: {},
  detailShare: {},
  clickCount: [],
  commentCount: {},
  productClaim: {},
  newProduct: [],
  productDistr: {
    yearList: [],
    categoryList: []
  },
  top10Product: [],
  functions: [],
  functionClaim: [],
  trendData: [],
  annualData: {
    monthList: [],
    proviceList: []
  },
  consumerAnn: {
    sexList: [],
    skinList: []
  },
  brandGroup: [],
  countryList: [],
  brandYearList: [],
  positionMap: [],
  groupList: [],
  groupList2: [],
  subCategory: [],
  areaDetail: [],
  segmentList: [],
  subSegmentList: [],
  usingTrend: [],
  brandDetail: {},
  exportCount: 0,
  brandSuggested: {},
  originList: [],
  ageData: [],
  relateBasfProducts: [],
  consumerClickData: {
    currentYearList: [],
    lastYearList: [],
  },
  consumerCommentData: {
    currentYearList: [],
    lastYearList: [],
  },
  commentProvincesData: [],
  countryNamesList: [],
  searchedClaimList: [],
}

const getters = {
  brandSearchList: state => state.brandSearchList.map(v => {
    return { label: v.name, value: v.id }
  }),
  brandList: state => state.brandList,
  pager: state => state.pager,
  claimList: state => state.claimList,
  categoryList: state => state.categoryList.map(v => {
    return { label: v.name, value: v.id }
  }),
  top5Claim: state => state.top5Claim,
  productCategory: state => state.productCategory,
  categoryClaim: state => state.categoryClaim,
  detailMarket: state => state.detailMarket,
  detailShare: state => state.detailShare,
  clickCount: state => state.clickCount,
  commentCount: state => state.commentCount,
  productClaim: state => state.productClaim,
  newProduct: state => state.newProduct,
  productDistr: state => state.productDistr,
  top10Product: state => state.top10Product,
  functions: state => state.functions.map(v => {
    return { label: v.title, value: v.id }
  }),
  functionClaim: state => state.functionClaim.map(v => {
    return { label: v.title, value: v.id }
  }),
  trendData: state => state.trendData,
  usingTrend: state => state.usingTrend,
  annualData: state => state.annualData,
  consumerAnn: state => state.consumerAnn,
  brandGroup: state => state.brandGroup,
  countryList: state => state.countryList.map(v => {
    return { label: v.countryName, value: v.countryId }
  }),
  brandYearList: state => {
    const current = state.brandYearList.filter(v => v.mark)
    return {
      list: state.brandYearList,
      default: current.length ? current[0].yearId : ''
    }
  },
  positionMap: state => state.positionMap,
  groupList: state => state.groupList.map(v => {
    return { label: v.name, value: v.id }
  }),
  groupList2: state => state.groupList2.map(v => {
    return { label: v.name, value: v.id }
  }),
  subCategory: state => state.subCategory.map(v => {
    return { label: v.name, value: v.id }
  }),
  areaDetail: state => state.areaDetail,
  segmentList: state => state.segmentList.map(v => {
    return { label: v.name, value: v.id }
  }),
  subSegmentList: state => state.subSegmentList.map(v => {
    return { label: v.name, value: v.id }
  }),
  brandDetail: state => state.brandDetail,
  exportCount: state => state.exportCount,
  brandSuggested: state => state.brandSuggested,
  originList: state => state.originList,
  ageData: state => state.ageData,
  relateBasfProducts: state => state.relateBasfProducts,
  consumerClickData: state => state.consumerClickData,
  consumerCommentData: state => state.consumerCommentData,
  commentProvincesData: state => state.commentProvincesData,
  countryNamesList: state => state.countryNamesList,
  searchedClaimList: state => state.searchedClaimList
}

const mutations = {
  [UPDATE_BRAND_SEARCH_LIST] (state, brandSearchList) {
    state.brandSearchList = brandSearchList
  },
  [UPDATE_BRAND_LIST] (state, brandList) {
    state.brandList = brandList
  },
  [UPDATE_PAGER] (state, pager) {
    state.pager = { ...state.pager, ...pager }
  },
  [UPDATE_CLAIM_LIST] (state, claimList) {
    state.claimList = claimList
  },
  [UPDATE_CATEGORY_LIST] (state, categoryList) {
    state.categoryList = categoryList
  },
  [UPDATE_TOP5_CLAIM] (state, top5Claim) {
    state.top5Claim = top5Claim
  },
  [UPDATE_PRODUCT_CATEGORY] (state, productCategory) {
    state.productCategory = productCategory
  },
  [UPDATE_CATEGORY_CLAIM] (state, categoryClaim) {
    // state.categoryClaim = categoryClaim
    state.categoryClaim.categoryDetail = categoryClaim.categoryDetail || []
    state.categoryClaim.claimDetail = categoryClaim.claimDetail || []
  },
  [UPDATE_DETAIL_MARKET] (state, detailMarket) {
    state.detailMarket = detailMarket
  },
  [UPDATE_DETAIL_SHARE] (state, detailShare) {
    state.detailShare = detailShare
  },
  [UPDATE_CLICK_COUNT] (state, clickCount) {
    state.clickCount = clickCount
  },
  [UPDATE_COMMENT_COUNT] (state, commentCount) {
    state.commentCount = commentCount
  },
  [UPDATE_PRODUCT_CLAIM] (state, productClaim) {
    state.productClaim = productClaim
  },
  [UPDATE_NEW_PRODUCT] (state, newProduct) {
    state.newProduct = newProduct
  },
  [UPDATE_PRODUCT_DISTR] (state, productDistr) {
    state.productDistr = productDistr
  },
  [UPDATE_TOP10_PRODUCT] (state, top10Product) {
    state.top10Product = top10Product
  },
  [UPDATE_FUNCTION] (state, functions) {
    state.functions = functions
  },
  [UPDATE_FUNCTION_CLAIM] (state, functionClaim) {
    state.functionClaim = functionClaim
  },
  [UPDATE_TREND_DATA] (state, trendData) {
    state.trendData = trendData
  },
  [UPDATE_ANNUAL_DATA] (state, annualData) {
    state.annualData = annualData
  },
  [UPDATE_CONSUMER_ANN] (state, consumerAnn) {
    state.consumerAnn = consumerAnn
  },
  [UPDATE_BRAND_GROUP] (state, brandGroup) {
    state.brandGroup = brandGroup
  },
  [UPDATE_COUNTRY] (state, countryList) {
    state.countryList = countryList
  },
  [UPDATE_BRAND_YEAR] (state, brandYearList) {
    state.brandYearList = brandYearList
  },
  [UPDATA_POSITION_MAP] (state, positionMap) {
    state.positionMap = positionMap
  },
  [UPDATE_GROUP_LIST] (state, groupList) {
    state.groupList = groupList
  },
  [UPDATE_GROUP_LIST2] (state, groupList2) {
    state.groupList2 = groupList2
  },
  [UPDATE_SUB_CATEGORY] (state, subCategory) {
    state.subCategory = subCategory
  },
  [UPDATE_AREA_DETAIL] (state, areaDetail) {
    state.areaDetail = areaDetail
  },
  [UPDATE_SEGMENT_LIST] (state, segmentList) {
    state.segmentList = segmentList
  },
  [UPDATE_SUB_SEGMENT_LIST] (state, subSegmentList) {
    state.subSegmentList = subSegmentList
  },
  [UPDATE_USING_TREND] (state, usingTrend) {
    state.usingTrend = usingTrend
  },
  [UPDATE_BRAND_DETAIL] (state, brandDetail) {
    state.brandDetail = brandDetail
  },
  [UPDATE_EXPORT_COUNT] (state, exportCount) {
    state.exportCount = exportCount
  },
  [UPDATE_BRAND_SUGGESTED] (state, brandSuggested) {
    state.brandSuggested = brandSuggested
  },
  [UPDATE_ORIGIN_LIST] (state, originList) {
    state.originList = originList
  },
  [UPDATE_AGE_DATA] (state, ageData) {
    state.ageData = ageData
  },
  [UPDATE_RELATED_BASF_PRODUCTS] (state, relateBasfProducts) {
    state.relateBasfProducts = relateBasfProducts
  },
  [UPDATE_CONSUMER_CLICK_DATA] (state, consumerClickData) {
    state.consumerClickData = consumerClickData
  },
  [UPDATE_CONSUMER_COMMENT_DATA] (state, consumerCommentData) {
    state.consumerCommentData = consumerCommentData
  },
  [UPDATE_COMMENT_PROVINCES_DATA] (state, commentProvincesData) {
    state.commentProvincesData = commentProvincesData
  },
  [UPDATE_COUNTRY_NAMES_LIST] (state, countryNamesList) {
    state.countryNamesList = countryNamesList
  },
  [UPDATE_SEARCH_CLAIM_LIST] (state, searchedClaimList) {
    state.searchedClaimList = searchedClaimList
  }
}
const actions = {
  // 获取brand search列表
  async getBrandSearchApi ({ commit }, params) {
    try {
      const { data: res } = await getBrandSelect({ keyword: params })
      commit(UPDATE_BRAND_SEARCH_LIST, res)
    } catch (e) {}
  },
  // 获取brand列表
  async getBrandDataApi ({ commit }, params) {
    try {
      const { data: res } = await getBrandData(params)
      const { data, total } = { ...res }
      commit(UPDATE_BRAND_LIST, data || [])
      commit(UPDATE_PAGER, { total: total || 0 })
    } catch (e) {}
  },
  // 获取宣称
  async getClaimDataApi ({ commit }, params) {
    try {
      const { data: res } = await getClaimData({keyword: params, tname: 'goods'})
      commit(UPDATE_CLAIM_LIST, res)
    } catch (e) {
      commit(UPDATE_CLAIM_LIST, [])
    }
  },
  // 获取category
  async getCategoryDataApi ({ commit }) {
    try {
      const { data: res } = await getCategoryData()
      commit(UPDATE_CATEGORY_LIST, res)
    } catch (e) {}
  },
  // 获取top5宣称
  async getTop5ClaimApi ({ commit }, params) {
    try {
      const { data: res } = await getTop5ClaimData(params)
      commit(UPDATE_TOP5_CLAIM, res)
    } catch (e) {}
  },
  // 获取产品分类
  async getProductCategoryApi ({ commit }, params) {
    try {
      const { data: res } = await getProductCategory(params)
      commit(UPDATE_PRODUCT_CATEGORY, res)
    } catch (e) {
      commit(UPDATE_PRODUCT_CATEGORY, {
        listdata: []
      })
    }
  },
  // 获取最热门十大产品宣称类别分布
  async getCategoryClaimApi ({ commit }, params) {
    try {
      const { data: res } = await getCategoryClaim(params)
      commit(UPDATE_CATEGORY_CLAIM, res)
    } catch (e) {
      commit(UPDATE_CATEGORY_CLAIM, {
        categoryDetail: [],
        claimDetail: []
      })
    }
  },
  // 获取品牌零售价与市场份额
  async getDetailMarketApi ({ commit }, params) {
    try {
      const { data: res } = await getDetailMarket(params)
      commit(UPDATE_DETAIL_MARKET, res)
    } catch (e) {
      commit(UPDATE_DETAIL_MARKET, {})
    }
  },
  // 获取市场份额
  async getDetailShareApi ({ commit }, params) {
    try {
      const { data: res } = await getDetailShare(params)
      commit(UPDATE_DETAIL_SHARE, res)
    } catch (e) {
      commit(UPDATE_DETAIL_SHARE, {})
    }
  },
  // 获取点击量
  async getClickDataApi ({ commit }, params) {
    try {
      const { data: res } = await getClickData(params)
      commit(UPDATE_CLICK_COUNT, res)
    } catch (e) {
      commit(UPDATE_CLICK_COUNT, [])
    }
  },
  // 获取评论
  async getCommentDataApi ({ commit }, params) {
    try {
      const { data: res } = await getCommentData(params)
      commit(UPDATE_COMMENT_COUNT, res)
    } catch (e) {
      commit(UPDATE_COMMENT_COUNT, {})
    }
  },
  // 产品年度5大宣称
  async getProductClaimApi ({ commit }, params) {
    try {
      const { data: res } = await getProductClaim(params)
      commit(UPDATE_PRODUCT_CLAIM, res)
    } catch (e) {
      commit(UPDATE_PRODUCT_CLAIM, {})
    }
  },
  // 获取产品三大全新发布
  async getNewProductApi ({ commit }, params) {
    try {
      const { data: res } = await getNewProduct(params)
      commit(UPDATE_NEW_PRODUCT, res)
    } catch (e) {
      commit(UPDATE_NEW_PRODUCT, [])
    }
  },
  // 获取品牌产品年度发布分布
  async getProductDistrApi ({ commit }, params) {
    try {
      const { data: res } = await getProcductDistr(params)
      commit(UPDATE_PRODUCT_DISTR, res)
    } catch (e) {
      commit(UPDATE_PRODUCT_DISTR, {
        yearList: [],
        categoryList: []
      })
    }
  },
  // 获取10大产品
  async getTop10ProductApi ({ commit }, params) {
    try {
      const { data: res } = await getTop10Product(params)
      commit(UPDATE_TOP10_PRODUCT, res)
    } catch (e) {
      commit(UPDATE_TOP10_PRODUCT, [])
    }
  },
  // 获取功能
  async getFunctionApi ({ commit }) {
    try {
      const { data: res } = await getFunction()
      commit(UPDATE_FUNCTION, res)
    } catch (e) {}
  },
  // 获取功能——宣称
  async getFunctionClaimApi ({ commit }, params) {
    try {
      const { data: res } = await getFunctionClaim(params)
      commit(UPDATE_FUNCTION_CLAIM, res)
    } catch (e) {}
  },
  // 获取成分使用趋势
  async getTrendDataApi ({ commit }, params) {
    try {
      const { data: res } = await getTrendData(params)
      commit(UPDATE_TREND_DATA, res)
    } catch (e) {
      commit(UPDATE_TREND_DATA, [])
    }
  },
  // 获取成分使用趋势
  async getUsingTrendApi ({ commit }, params) {
    try {
      const { data: res } = await getTrendData(params)
      commit(UPDATE_USING_TREND, res)
    } catch (e) {
      commit(UPDATE_USING_TREND, [])
    }
  },
  // 获取年度画像
  async getAnnualDataApi ({ commit }, params) {
    try {
      const { data: res } = await getAnnualData(params)
      commit(UPDATE_ANNUAL_DATA, res)
    } catch (e) {
      commit(UPDATE_ANNUAL_DATA, {
        monthList: [],
        proviceList: []
      })
    }
  },
  // 获取年度画像（用户）
  async getConsumerAnnApi ({ commit }, params) {
    try {
      const { data: res } = await getConsumerAnn(params)
      commit(UPDATE_CONSUMER_ANN, res)
    } catch (e) {
      commit(UPDATE_CONSUMER_ANN, {
        sexList: [],
        skinList: []
      })
    }
  },
  // 获取集团下品牌
  async getBrandGroupApi ({ commit }, params) {
    try {
      const { data: res } = await getBrandGroup(params)
      commit(UPDATE_BRAND_GROUP, res)
    } catch (e) {}
  },
  // 获取国家
  async getCountryApi ({ state, commit }, params) {
    if (state.country && state.country.length) return
    try {
      const { data: res } = await getCountryData(params)
      commit(UPDATE_COUNTRY, res)
    } catch (e) {}
  },
  // 获取品牌下年份字典
  async getBrandYearApi ({ state, commit }) {
    if (state.brandYearList && state.brandYearList.length) return
    try {
      const { data: res } = await getBrandYear()
      commit(UPDATE_BRAND_YEAR, res)
    } catch (e) {}
  },
  // 获取品牌定位数据
  async getPositionMapApi ({ commit }, params) {
    try {
      const { data: res } = await getPositionMap(params)
      commit(UPDATA_POSITION_MAP, res)
    } catch (e) {}
  },
  // 获取brand group模糊查询
  async getGroupListApi ({ commit }, params) {
    try {
      const { data: res } = await getGroupList(params)
      commit(UPDATE_GROUP_LIST, res)
      return res || []
    } catch (e) {}
  },
  // 获取brand group模糊查询
  async getGroupListApi2 ({ commit }, params) {
    try {
      const { data: res } = await getGroupList(params)
      commit(UPDATE_GROUP_LIST2, res)
    } catch (e) {}
  },
  // 获取sub category
  async getSubCategoryApi ({ commit }, params) {
    try {
      const { data: res } = await getSubCategory(params)
      commit(UPDATE_SUB_CATEGORY, res)
    } catch (e) {}
  },
  // 获取地区详情
  async getAreaDetailApi ({ commit }, params) {
    try {
      const { data: res } = await getAreaDetail(params)
      commit(UPDATE_AREA_DETAIL, res)
    } catch (e) {}
  },
  // 获取segment
  async getSegmentApi ({ commit }) {
    try {
      const { data: res } = await getSegmentList({ pid: 0, marketSegment: 0 })
      commit(UPDATE_SEGMENT_LIST, res)
    } catch (e) {}
  },
  // 获取sub-segment
  async getSubSegmentApi ({ commit }, params) {
    try {
      const { data: res } = await getSegmentList({ pid: params, marketSegment: 0 })
      commit(UPDATE_SUB_SEGMENT_LIST, res)
    } catch (e) {}
  },
  setPagerApi ({ commit }, pager) {
    commit(UPDATE_PAGER, pager)
  },
  // 获取brand详情
  async getBrandDetailApi ({ commit }, params) {
    try {
      const { data: res } = await getBrandDetail(params)
      commit(UPDATE_BRAND_DETAIL, res || {})
      return true
    } catch (e) {
      return false
    }
  },
  // 获取导出数据数量
  async getExportCountApi ({ commit }, params) {
    try {
      const { data: res } = await getExportCount(params)
      commit(UPDATE_EXPORT_COUNT, res || 0)
      return true
    } catch (e) {
      return false
    }
  },
  // 获取品牌建议
  async getBrandSuggestedApi ({ commit }, params) {
    try {
      const { data: res } = await getBrandSuggested(params)
      commit(UPDATE_BRAND_SUGGESTED, res)
    } catch (e) {}
  },
  async getUpdateItemApi ({ commit }, params) {
    try {
      let { data: res } = await getUpdateItem()
      return res
    } catch (e) { }
  },
  async getOriginListApi ({ commit }, params) {
    try {
      let { data: res } = await getOriginList(params)
      commit(UPDATE_ORIGIN_LIST, res)
      return res
    } catch (e) { }
  },
  async getAgeDataApi ({ commit }, params) {
    try {
      let { data: res } = await getAgeData(params)
      commit(UPDATE_AGE_DATA, res)
      return res
    } catch (e) { }
  },
  async getRelateBasfProductsApi ({ commit }, params) {
    try {
      let { data: res } = await getRelateBasfProducts(params)
      commit(UPDATE_RELATED_BASF_PRODUCTS, res)
      return res
    } catch (e) { }
  },
  async getConsumerClickDataApi ({ commit }, params) {
    try {
      let { data: res } = await getConsumerClickData(params)
      commit(UPDATE_CONSUMER_CLICK_DATA, res)
      return res
    } catch (e) { }
  },
  async getConsumerCommentDataApi ({ commit }, params) {
    try {
      let { data: res } = await getConsumerCommentData(params)
      commit(UPDATE_CONSUMER_COMMENT_DATA, res)
      return res
    } catch (e) { }
  },
  async getCommentProvincesDataApi ({ commit }, params) {
    try {
      let { data: res } = await getCommentProvincesData(params)
      commit(UPDATE_COMMENT_PROVINCES_DATA, res)
      return res
    } catch (e) { }
  },
  // 获取国家全称
  async getCountryNamesApi ({ state, commit }, params) {
    if (state.countryNamesList && state.countryNamesList.length) return
    try {
      const { data: res } = await getCountryNamesData(params)
      commit(UPDATE_COUNTRY_NAMES_LIST, res || [])
    } catch (e) {}
  },
  // 获取宣称
  async searchClaimDataByTitleApi ({ commit }, params) {
    try {
      const { data: res } = await getClaimData({title: params, tname: 'goods'})
      commit(UPDATE_SEARCH_CLAIM_LIST, (res || []).map(v => {
        return {
          id: v.id,
          title: v.title
        }
      }))
    } catch (e) {
      commit(UPDATE_SEARCH_CLAIM_LIST, [])
    }
  },
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/brandAnalytics.js